var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "20px",
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "downArrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "downArrow",
    transform: "translate(15.000000, 10.000000) rotate(-270.000000) translate(-15.000000, -10.000000) translate(5.000000, -5.000000)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.376574608,29.4688086 C-0.185216322,28.8302224 -0.110310862,27.8647045 0.541990818,27.3147259 L15.1423127,15.0043729 L0.541990818,2.68485355 C-0.110310862,2.13181957 -0.185216322,1.16935712 0.376574608,0.530770918 C0.944607648,-0.110870712 1.92462071,-0.178090312 2.5769224,0.371888228 L18.550511,13.8463625 C18.8938277,14.136629 19.0904545,14.5582792 19.0904545,15.0043729 C19.0904545,15.4474111 18.8938277,15.8690614 18.5473899,16.1623833 L2.5769224,29.6307467 C2.28354269,29.8751816 1.92149965,30.0004545 1.55945661,30.0004545 C1.12250811,30.0004545 0.688680678,29.8201838 0.376574608,29.4688086 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.ebdc3b3087536686304cdbeaa3497d2f.svg";
export { ForwardRef as ReactComponent };